module.exports = __webpack_public_path__ + "static/img/shiyongjiaocheng.f7a030f.png";


//////////////////
// WEBPACK FOOTER
// ./static/shiyongjiaocheng.png
// module id = tzO8
// module chunks = 1